import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { updateInformationConfirmed } from '../../../states/containers/common/currentSlice'

interface InfoDetail {
  id: number
  text: string
  url: string | null
  background_color: string
  text_color: string
  confirmed: boolean
}

const InfoBar: FC = () => {
  const dispatch = useDispatch()

  const {
    information,
    current,
  } = useSelector((state: RootState) => state)

  const [infoDetail, setInfoDetail] = useState<InfoDetail | undefined>(undefined)

  const confirmInfo = (id: number) => {
    if (!id || !infoDetail) return
    setInfoDetail(
      {
        ...infoDetail,
        confirmed: true,
      },
    )
    dispatch(updateInformationConfirmed([...current.informationConfirmed, id]))
  }

  useEffect(() => {
    if (!information.information?.header_information) return
    const tmp = information.information?.header_information
    setInfoDetail(
      {
        ...tmp,
        confirmed: current.informationConfirmed.includes(tmp.id),
      },
    )
  }, [information.information?.header_information])

  return (
    <div>
      {
        infoDetail && !infoDetail.confirmed && (
          <div
            className="info_bar"
            style={{
              backgroundColor: infoDetail.background_color,
              color: infoDetail.text_color,
            }}
          >
            {
              infoDetail.url ? (
                <a
                  href={infoDetail.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: infoDetail.text_color,
                    textDecoration: "underline",
                  }}
                >
                  {infoDetail.text}
                </a>
              ) : (
                <>
                  {infoDetail.text}
                </>
              )
            }
            <button
              type="button"
              style={{
                position: "absolute",
                top: "50%",
                right: "0px",
                transform: "translateY(-50%)",
                color: infoDetail.text_color,
              }}
              onClick={() => confirmInfo(infoDetail.id)}
            >
              <FontAwesomeIcon
                icon={['fas', 'times']}
              />
            </button>
          </div>
        )
      }
    </div>
  )
}

export default InfoBar
